import React from 'react';

const hero = (props) => {

        const styles = {
            backgroundColor: 'transparent',
            backgroundImage: 'url('+props.img+')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        };

    return (
        <section className="hero is-info is-medium"
                 style={styles}>
            <div className="container">
                <div className="hero-body">
                    <div className="container has-text-centered">
                        <h1 className="title">
                            {props.title}
                        </h1>
                        <h2 className="subtitle">
                            {props.subtitle}
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default hero;


// WEBPACK FOOTER //
// ./src/Components/UI/Hero/Hero.js